var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[(_vm.$store.state.currentGame.quest)?_c('div',[(_vm.$store.state.currentGame.character)?_c('confirm-start'):_c('choose-character')],1):_c('choose-quest')],1)}
var staticRenderFns = []

export { render, staticRenderFns }